module.exports = __webpack_public_path__ + "static/media/Cizplam_logo.db5b0f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cizplam_logo.png
// module id = 1364
// module chunks = 0